// The TEAMM8 brand mark. Full form = the official TEAMM8 wordmark logo (optionally with a
// "Wholesale" label). `compact` (collapsed sidebar) shows the T8W monogram — the same asset as
// the browser favicon, so the two always match.
export default function Wordmark({ compact = false, imgClass = 'h-6', showLabel = true }) {
  if (compact) {
    return <img src="/favicon.svg" alt="TEAMM8 Wholesale" className="h-8 w-8 shrink-0" />;
  }
  return (
    <span className="flex items-center gap-2">
      <img src="/teamm8-logo.png" alt="TEAMM8" className={`${imgClass} w-auto`} />
      {showLabel && <span className="text-sm font-medium tracking-tight text-text-muted">Wholesale</span>}
    </span>
  );
}
